@if (displayProperties$ | async; as properties) {
  <div class="flex layout-col gap-sm">
    @for (prop of properties | keyvalue; track prop) {
      <mat-form-field class="flex" elderFormFieldLabel subscriptSizing="dynamic">
        <mat-label>{{ prop.key }}</mat-label>
        <input
          matInput
          type="text"
          name="{{ prop.key }}"
          value="{{ prop.value }}"
          placeholder="{{ prop.key }}"
          readonly
        />
      </mat-form-field>
    }
  </div>
}
